<!--Este componente é que aparece no primeira página e faz a chamada para o página Fascias-->
<template>
  <div class="bg-[#033C48] py-12">
    <container id="fascias">
      <content-component :order1lg="'order-2'" :order2lg="'order-1'" :order1sm="'order-1'" :order2sm="'order-2'">

        <div class="w-full flex flex-col justify-center items-center mx-auto mb-8">
          <h2 class="font-bold text-white text-xl md:text-2xl text-center mb-2">
            Você tem algum desses problemas?
          </h2>
          <p class="text-white text-sm md:text-base text-center">
            As Fáscias podem ser a solução para você!
          </p>
        </div>

        <template #slot1>
          <img src="../../public/3293.webp" alt="" width="750" height="852"
               class="rounded-4xl"/>
        </template>
        <template #slot2>
          <div class="lg:px-12">
            <card-button title="Dores emocionais, ansiedade, depressão;"/>
            <card-button title="Hérnia de disco;"/>
            <card-button title="Dores nas pernas e braços;"/>
            <card-button title="Enxaqueca;"/>
            <card-button title="Gastrite nervosa;"/>
            <card-button title="Problemas no intestino;"/>
            <card-button title="Dores no ciático;"/>
            <card-button title="Dores na sola do pé;"/>
            <div class="w-full gap-y-12 lg:gap-y-0 mt-12 mb-12 flex flex-col lg:flex-row justify-center lg:justify-between items-center">
              <primary-button class="text-sm" title="Agende sua pré consulta"/>
              <secondary-button title="Saiba mais" link="/fascias"/>
            </div>
          </div>
        </template>
      </content-component>
    </container>
  </div>
</template>
<script>
import Container from "@/components/partials/Container.vue";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import ContentComponent from "@/components/partials/Content.vue";
import CardButton from "@/components/CardButton.vue";
import SecondaryButton from "@/components/buttons/SecondaryButton.vue";

export default {
  name: "FasciasComponent",
  components: {SecondaryButton, CardButton, ContentComponent, PrimaryButton, Container}
}
</script>